<div class="form-field">
  @if (props['label']) {
  <label [for]="id" class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }
  <input [id]="id" class="form-input" type="number" [formControl]="formControl" [formlyAttributes]="field"
    [placeholder]="props['placeholder'] || ''" [required]="props['required'] || false" [min]="props['min'] ?? null"
    [max]="props['max'] ?? null" [step]="props['step'] ?? null" />
  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }
  @if (formControl.touched && formControl.errors) {
  <div class="field-error">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>